import { GivingBack } from "../queries/aboutUsQuery";
import { getImageURL } from "../utils/getImageURL";
import { priceFormatter } from "../utils/priceFormatter";

export function AboutUsDonationSection({
  giving,
  totalDonated,
}: {
  giving: GivingBack;
  totalDonated: number;
}) {
  return (
    <>
      <div className="flex flex-col items-center justify-center text-center">
        <div className="flex items-center justify-center py-2 md:block">
          {giving.percentageImage && (
            <img
              src={getImageURL(giving.percentageImage).url()}
              alt={giving.bodyText}
            />
          )}
        </div>

        <div className="mt-3 text-pretty px-0 text-body-20 md:px-8">
          {giving.bodyText && <p>{giving.bodyText}</p>}
        </div>

        <div className="mt-5 text-body-15 text-onyx">
          <strong>
            {giving.labelTotalDonated && <p>{giving.labelTotalDonated}</p>}
          </strong>
        </div>

        <strong className="text-gradient-default font-rebrand text-[60px]">
          <em>{priceFormatter(totalDonated)}!</em>
        </strong>
      </div>
    </>
  );
}

export default AboutUsDonationSection;
